require('./RAPortfolioTrackingView.scss');
require('./RAPortfolioTrackingView.override.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { isEmpty } = require('lodash');
const { withRouter } = require('react-router-dom');

// @commons
const RACover = require('../../components/commons/RACover/RACover');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKLink } = require('commonsComponents/OKLink');
const RAInformativeBox = require('../../components/commons/RAInformativeBox/RAInformativeBox');
const { EmptyState } = require('commonsComponents/emptyState');
const { LoadingSection } = require('commonsComponents/loadingSection');
const OKModal = require('components/commons/OKModal/OKModal');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const { OKMessage } = require('commonsComponents/OKMessage');

// @constants
const { BROKER_PG_URL } = require('constants/index');
const {
    MINIMUM_STRATEGY_BALANCE_REIMBURSEMENT,
    MYPROFILE_BROKER_ROBO_URL,
    PORTFOLIO_TRACK_URL_PARA,
    PROC_RA_ACCORDION_DISTRIBUTION_CHEVRON,
    PROC_RA_YEARS,
    PROC_RA_ORDERS_AND_MOVEMENTS,
    PROC_RA_PORTFOLIO_TRACKING_ACCOUNT_DETAILS,
    PROC_RA_PORTFOLIO_TRACKING_ASSOCIATE_OBJECTIVE,
    PROC_RA_PORTFOLIO_TRACKING_CANCEL_PORTFOLIO,
    PROC_RA_PORTFOLIO_TRACKING_EXPECTED_PROFITABILITY,
    PROC_RA_GLOBAL_POSITION_RETURN_TEST,
    PROC_RA_GO_BACK,
    PROC_RA_HELP_PATRIMONY_CALCULATION,
    PROC_RA_PORTFOLIO_TRACKING_INTERACTION,
    PROC_RA_MANAGE_CONTRIBUTIONS,
    PROC_RA_MODIFY_WALLET_NAME,
    PROC_RA_PORTFOLIO_TRACKING_MODIFY_STRATEGY,
    PROC_RA_NEW_CONTRIBUTION,
    PROC_RA_OPTIONS_MENU,
    PROC_RA_TRACKING_ORDERS_MOVEMENTS,
    PROC_RA_PORTFOLIO_TRACKING_REFUND,
    PROC_RA_TRACKING_SUITABILITY_TEST,
    RA_ACCOUNT_DETAILS_URL,
    RA_ADDITIONAL_CONTRIBUTION_URL,
    RA_ASSOCIATE_OBJECTIVE_URL,
    RA_CANCEL_PLAN_URL,
    RA_COVER_FONT,
    RA_FUND_TRANSFER_STEP1,
    RA_FUND_TRANSFER_STEP2,
    RA_FUND_TRANSFER_STEP3,
    RA_LAST_MOVEMENTS_URL,
    RA_MANAGEMENT_CONTRIBUTION_URL,
    RA_MODIFY_PLAN_URL,
    RA_PORTFOLIO_FUND_HIRING_METHOD,
    RA_REIMBURSEMENT_URL,
    RA_SUITABILITY_TEST_MODIFYPORTFOLIO_OPERATION,
    RA_SUITABILITY_TEST_URL,
    SUITABILITY_TEST_HIGH_CONSERVATIVE,
    SUITABILITY_TEST_STATUS_URL,
} = require('../../raConstants/index');
const {
    ESG_PRODUCT,
    MODIFY_SUITABILITY_TEST,
} = require('constants/flagBasedFeatures');

// @utilities
const { formatText, FormattedText } = require('core/i18n').i18n;
const {
    isTestValid,
    isTestExpired,
} = require('../../utilities/RASuitabilityTestHelper');

const {
    recordLink,
    PROC_RA_GLOBAL_POSITION_INTERACTION,
} = require('utilities/tagging');

// @components
const RAEvolutionChart = require('../../components/RAEvolutionChart/RAEvolutionChart');
const RAProjectionChart = require('../../components/RAProjectionChart/RAProjectionChart');
const RAAlertsWidget = require('../../components/RAAlertsWidget/RAAlertsWidget');
const {
    BrokerInvestmentSpecialist,
} = require('components/broker/brokerInvestmentSpecialist/brokerInvestmentSpecialist');
const RAContributions = require('../../components/RAObjectiveTracking/RAContributions/RAContributions');
const RAPillButtons = require('../../components/RAPillButtons/RAPillButtons');
const RAAccordionDistributionTable = require('../../components/RAAccordionDistributionTable/RAAccordionDistributionTable');
const RADistributionWidget = require('../../components/RADistributionWidget/RADistributionWidget');
const RARoboMoreOptionsButton = require('../../components/RARoboMoreOptionsButton/RARoboMoreOptionsButton');
const RAExpectedProfitability = require('../../components/RAExpectedProfitability/RAExpectedProfitability');
const RAFeatureFlagModal = require('../../components/RAFeatureFlagModal/RAFeatureFlagModal');
const RAInformativeModal = require('../../components/RAInformativeModal/RAInformativeModal');
const RAModifyPlanWarningModal = require('../../components/RAModifyPlanWarningModal/RAModifyPlanWarningModal');
const RACgdNumber = require('../../components/RACgdNumber/RACgdNumber');
const RAFundTransferNotification = require('../../components/RAFundTransferNotification/RAFundTransferNotification');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const WebappRender = require('components/conditionalRender/webappRender');
const FeatureTogglingRender = require('components/conditionalRender/featureTogglingRender');

// @actions
const brokerMyInvestments = require('actions/brokerMyInvestments');
const expectedProfitabilityActions = require('../../actions/RAExpectedProfitability');
const portfolioDetailsActions = require('../../actions/RAPortfolioDetails');
const raEvolutionChartOjectiveTracking = require('../../actions/RAEvolutionChartOjectiveTracking');
const raPortfoliosNameHistoryActions = require('../../actions/RAPortfoliosNameHistory');
const RAAlertsActions = require('../../actions/RAAlerts');
const RAFeatureFlagActions = require('../../actions/RAFeatureFlag');
const raAccountDetailsActions = require('../../actions/RAAccountDetails');
const raLastMovementActions = require('../../actions/RALastMovement');
const raGlobalPosition = require('../../actions/RAGlobalPosition');
const suitabilityActions = require('../../actions/RASuitabilityTest');

const headerIcons = {
    1: 'icon-KualaLumpur-small',
    2: 'icon-shangai-small',
    3: 'icon-taipei-small', // @TODO: test it when ezequiel upload icon-fonts
    4: 'icon-NewYork-small',
    5: 'icon-dubai-small',
};

class RAPortfolioTrackingView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isModalOpen: false,
            isModifyModalOpen: false,
            showFundTrasnferNotification: true,
            isPartialRefundModalOpen: false,
            showModalTestExpired: false,
            showUnsuitableTestCancelation: true,
        };
        this.handleAccordionDistributionTableLink = this.handleAccordionDistributionTableLink.bind(
            this,
        );
        this.handleAdditionalContribution = this.handleAdditionalContribution.bind(
            this,
        );
        this.handleFeatureModal = this.handleFeatureModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.handleEvolutionChartOptionChange = this.handleEvolutionChartOptionChange.bind(
            this,
        );
        this.handleModifyModalClick = this.handleModifyModalClick.bind(this);
        this.handleModifyModalClose = this.handleModifyModalClose.bind(this);
        this.handleProjectionChartYearsClick = this.handleProjectionChartYearsClick.bind(
            this,
        );
        this.handleOpenEvolutionModal = this.handleOpenEvolutionModal.bind(
            this,
        );
        this.handleTitleChange = this.handleTitleChange.bind(this);
        this.handleFundNotificationClose = this.handleFundNotificationClose.bind(
            this,
        );
        this.handlePartialRefundModalToggle = this.handlePartialRefundModalToggle.bind(
            this,
        );
        this.handleCloseModalTestExpired = this.handleCloseModalTestExpired.bind(
            this,
        );
        this.handleModalTestExpiredLink = this.handleModalTestExpiredLink.bind(
            this,
        );
        this.handleCloseUnsuitableTest = this.handleCloseUnsuitableTest.bind(
            this,
        );
        this.handleReturnTestClick = this.handleReturnTestClick.bind(this);
    }

    componentDidMount() {
        const {
            fetchMyInvestments,
            readPortfolioFromGlobalPosition,
            immBrokerMyInvestments,
            immGlobalPosition,
            match: {params: { portfolioId }},
            fetchFeatureFlag,
            getCGDAccountNumberVal,
            getDisplayNames,
            removeFilter,
            setOriginRedirection,
        } = this.props;
        setOriginRedirection(PORTFOLIO_TRACK_URL_PARA, portfolioId);
        fetchFeatureFlag();
        getCGDAccountNumberVal(portfolioId);
        getDisplayNames();
        removeFilter();

        if (
            (immBrokerMyInvestments.get('isOutdated') &&
                !immBrokerMyInvestments.get('isFetching')) ||
            !immGlobalPosition.get('hasRoboHired')
        ) {
            fetchMyInvestments().then(() => {
                readPortfolioFromGlobalPosition(portfolioId);
            });
        } else {
            readPortfolioFromGlobalPosition(portfolioId);
        }
    }

    componentDidUpdate(prevProps) {
        const { immPortfolioDetails, immGlobalPosition } = this.props;
        const immPrevPortfolioDetails = prevProps.immPortfolioDetails;
        const prevPortfolioDetailSuccess = immPrevPortfolioDetails.get(
            'isSuccess',
        );
        const portfolioDetailSuccess = immPortfolioDetails.get('isSuccess');
        const prevPortfolioId = immPrevPortfolioDetails.get('portfolioId');
        const portfolioId = immPortfolioDetails.get('portfolioId');

        if (
            prevPortfolioDetailSuccess !== portfolioDetailSuccess ||
            prevPortfolioId !== portfolioId
        ) {
            const portfolioStartDate = immPortfolioDetails.get(
                'portfolioStartDate',
            );
            const product = immPortfolioDetails.getIn([
                'product',
                'typeOfProduct',
            ]);
            const balance = immPortfolioDetails.getIn([
                'totals',
                'investedAmount',
            ]);
            this.props.requestPortfolioEvolutionChart(
                portfolioId,
                portfolioStartDate,
            );
            const recurringContributionAmount = immGlobalPosition.getIn([
                'portfolios',
                portfolioId,
                'recurringTransfers',
                'amount',
            ]);
            const periodicity = immGlobalPosition.getIn([
                'portfolios',
                portfolioId,
                'recurringTransfers',
                'recurringCode',
            ]);
            this.props.requestProjectionChart({
                product,
                balance,
                portfolioId,
                freq: periodicity,
                mntPayment: recurringContributionAmount,
            });
        }
    }

    componentWillUnmount() {
        this.props.reset();
        this.props.resetExpectedProfitability();
    }

    handleOpenEvolutionModal() {
        this.setState({
            isModalOpen: true,
        });
    }

    handleCloseModal() {
        this.setState({
            isModalOpen: false,
        });
    }

    handleModifyModalClick() {
        this.setState({
            isModifyModalOpen: true,
        });
    }

    handleModifyModalClose() {
        this.setState({
            isModifyModalOpen: false,
        });
    }

    handlePartialRefundModalToggle() {
        this.setState({
            isPartialRefundModalOpen: !this.state.isPartialRefundModalOpen,
        });
    }

    handleTitleChange(newName) {
        const {
            immPortfoliosNameHistory,
            immPortfolioDetails,
            match: {params: { portfolioId }},
        } = this.props;
        const namesHistory = immPortfoliosNameHistory.get('namesHistory');
        const nameExists = namesHistory.some(
            name => name.toLowerCase() === newName.toLowerCase(),
        );
        if (!nameExists) {
            // In this case the name not exist so is valid to update portfolio name
            const originalName = immPortfolioDetails.get('portfolioName');
            const namePosition = namesHistory.findIndex(
                name => name.toLowerCase() === originalName.toLowerCase(),
            );
            this.props.updatePortfolioName(portfolioId, newName, namePosition);
        } else {
            this.props.setHeaderTitleError();
        }
        recordLink(
            PROC_RA_PORTFOLIO_TRACKING_INTERACTION,
            PROC_RA_MODIFY_WALLET_NAME,
        );
    }

    formatter(value) {
        return (
            <FormattedText
                value="raPortfolioTracking-nYears"
                injectedStrings={[value]}
            />
        );
    }

    getBreadcrumb() {
        return [
            {
                text: formatText(
                    'raPortfolioTracking-raPortfolioTracking_breadcrumbFirst',
                ),
                url: BROKER_PG_URL,
            },
            {
                text: formatText(
                    'raPortfolioTracking-raPortfolioTracking_breadcrumbSecond',
                ),
                url: MYPROFILE_BROKER_ROBO_URL,
            },
            {
                text: formatText(
                    'raPortfolioTracking-raPortfolioTracking_breadcrumbThird',
                ),
            },
        ];
    }

    getChartSection() {
        const { immEvolutionChartData, immPortfolioDetails } = this.props;
        let content;
        const evolutionChartData = immEvolutionChartData.get('data').toJS();
        const evolutionChartSelectedOption = immEvolutionChartData.get(
            'selectedOption',
        );
        const error = !!immEvolutionChartData.get('error');
        const chartDataFetching = immEvolutionChartData.get('isFetching');
        const isFetchingDetail = immPortfolioDetails.get('isFetching');
        const loading = chartDataFetching || isFetchingDetail;
        if (loading) {
            content = <LoadingSection />;
        } else if (error) {
            content = (
                <EmptyState
                    primaryText={formatText(
                        'raObjectiveTracking-raObjectiveTracking_apiFailure',
                    )}
                    iconType="nointernet-wealth"
                />
            );
        } else {
            const isGraphDisabled =
                isEmpty(evolutionChartData) || evolutionChartData.length < 2;
            content = (
                <RAEvolutionChart
                    data={evolutionChartData}
                    selectedOption={evolutionChartSelectedOption}
                    disabled={isGraphDisabled}
                />
            );
        }
        return content;
    }

    getPillSection() {
        const { immEvolutionChartData } = this.props;
        const evolutionChartData = immEvolutionChartData.get('data').toJS();
        const evolutionChartButtons = immEvolutionChartData
            .get('chartButtons')
            .toJS();
        const evolutionChartSelectedOption = immEvolutionChartData.get(
            'selectedOption',
        );

        if (!isEmpty(evolutionChartData)) {
            return (
                <RAPillButtons
                    buttons={evolutionChartButtons}
                    changeOption={this.handleEvolutionChartOptionChange} // eslint-disable-line
                    selectedOption={evolutionChartSelectedOption}
                    disabled={false}
                />
            );
        }
    }

    buildEmptyEvolutionModal() {
        return (
            <RAInformativeModal
                isModalOpen={this.state.isModalOpen}
                onModalClose={this.handleCloseModal}
                textKey="raEmptyEvolutionModal"
            />
        );
    }

    getSubtitle() {
        const { immEvolutionChartData } = this.props;
        const evolutionChartData = immEvolutionChartData.get('data').toJS();

        let content = (
            <div className="ra-portfolio-tracking-view__evolution-section-description">
                <FormattedText
                    className="ra-portfolio-tracking-view__evolution-paragraph"
                    value="raPortfolioTracking-evolutionParagraph"
                />
            </div>
        );

        if (isEmpty(evolutionChartData) || evolutionChartData.length < 2) {
            content = (
                <div className="ra-portfolio-tracking-view__evolution-section-description">
                    <OKLink
                        onClick={this.handleOpenEvolutionModal}
                        modifier="complementary"
                    >
                        <FormattedText value="raEmptyEvolutionModal-raEmptyEvolutionModal_link" />
                    </OKLink>
                </div>
            );
        }

        return content;
    }

    getPortfolioEvolution() {
        const chartSection = this.getChartSection();
        const pillSection = this.getPillSection();
        const subtitle = this.getSubtitle();

        return (
            <section className="ra-portfolio-tracking-view__evolution-section">
                <header>
                    <div className="ra-portfolio-tracking-view__evolution-section-buttons">
                        <div>
                            <h3 className="ra-portfolio-tracking-view__evolution-title">
                                <FormattedText value="raPortfolioEvolution-title" />
                            </h3>
                            {subtitle}
                        </div>
                        <div className="ra-portfolio-tracking-view__evolution-section-pillbuttons">
                            {pillSection}
                        </div>
                    </div>
                </header>
                {chartSection}
            </section>
        );
    }

    getExpectedProfitability() {
        const { immExpectedProfitability, immPortfolioDetails } = this.props;
        const chartYears = immExpectedProfitability.get('chartYears');
        const chartButtons = immExpectedProfitability.get('chartButtons');
        const chartData = immExpectedProfitability.get('chartData').toJS();
        const chartDataFetching = immExpectedProfitability.get('isFetching');
        const isFetchingDetail = immPortfolioDetails.get('isFetching');
        const error = immExpectedProfitability.get('error');
        return (
            <section className="ra-portfolio-tracking-view__projection-section">
                <div className="ra-portfolio-tracking-view__profitability">
                    <WebappRender>
                        <RAExpectedProfitability
                            changeYears={this.handleProjectionChartYearsClick} // eslint-disable-line
                            chartButtons={chartButtons}
                            chartData={chartData}
                            chartYears={chartYears}
                            error={!!error}
                            headerMarginBottom={true}
                            loading={chartDataFetching || isFetchingDetail}
                            showFooter={false}
                            title={formatText(
                                'rentabilityGraph-expectedRentability',
                            )}
                        />
                    </WebappRender>
                    <ContactCenterRender>
                        <div className="ra-portfolio-tracking-view__profitability__header">
                            <div className="ra-portfolio-tracking-view__profitability__header-texts">
                                <h2 className="ra-portfolio-tracking-view__profitability__title">
                                    <FormattedText value="rentabilityGraph-expectedRentability" />
                                </h2>
                            </div>
                            <div className="ra-portfolio-tracking-view__profitability__buttons">
                                <RAPillButtons
                                    changeOption={ // eslint-disable-line
                                        this.handleProjectionChartYearsClick
                                    }
                                    selectedOption={chartYears}
                                    formatter={this.formatter}
                                    buttons={chartButtons}
                                    disabled={false}
                                />
                            </div>
                        </div>
                        <RAProjectionChart
                            data={chartData}
                            years={chartYears}
                            loading={false}
                            disabled={false}
                        />
                    </ContactCenterRender>
                </div>
                <div>
                    <h4 className="ra-portfolio-tracking-view__projection-question-title">
                        <FormattedText value="raPortfolioTracking-projectionQuestionTitle" />
                    </h4>
                    <FormattedText
                        className="ra-portfolio-tracking-view__projection-question-para"
                        value="raPortfolioTracking-projectionQuestionParagraph"
                    />
                </div>
            </section>
        );
    }

    handleAccordionDistributionTableLink(assetClassName) {
        recordLink(
            PROC_RA_PORTFOLIO_TRACKING_INTERACTION,
            PROC_RA_ACCORDION_DISTRIBUTION_CHEVRON,
            assetClassName,
        );
    }

    handleOrdersAndMovementsrecordLink() {
        recordLink(
            PROC_RA_PORTFOLIO_TRACKING_INTERACTION,
            PROC_RA_ORDERS_AND_MOVEMENTS,
        );
    }

    getPortfolioDistribution(isCancelInProgress) {
        const {
            immPortfolioDetails,
            match: { params: { portfolioId } },
        } = this.props;
        const immAssetAllocations = immPortfolioDetails.get('assetAllocation');
        const coverTitle = immPortfolioDetails.get('portfolioName');
        const portfolioDistributionTableTitle =
            formatText('raPortfolioTracking-distributionDetailsTitle') +
            ' ' +
            coverTitle;

        let movementsLink;
        if (!isCancelInProgress) {
            movementsLink = (
                <div className="ra-global-position__link--right">
                    <OKLink
                        to={`${RA_LAST_MOVEMENTS_URL}/${PORTFOLIO_TRACK_URL_PARA}/${portfolioId}`}
                        modifier="complementary"
                        onClick={this.handleOrdersAndMovementsrecordLink}
                    >
                        <FormattedText value="raGlobalPosition-raGlobalPosition_goToOrdersAndMovements" />
                    </OKLink>
                </div>
            );
        }

        return (
            <div className="col-xs-12 col-sm-6 col-md-12 grid-view--fix-cell-separation">
                <div className="ra-portfolio-tracking-view__section-table">
                    <div className="ra-portfolio-tracking-view__header-table-section">
                        <h2 className="ra-portfolio-tracking-view__section-title">
                            {portfolioDistributionTableTitle}
                        </h2>
                        <FormattedText value="raPortfolioTracking-distributionParagraph" />
                    </div>
                    <FeatureTogglingRender notAllowedProductKey={ESG_PRODUCT}>
                        <div className="ra-portfolio-tracking-view__section-esg-tag">
                            <i className="ra-portfolio-tracking-view__section-esg-icon" />
                            <FormattedText value="raPortfolioTracking-raPortfolioTracking_esgTag" />
                        </div>
                    </FeatureTogglingRender>
                    <RAAccordionDistributionTable
                        immKeyFigures={immPortfolioDetails.get('totals')}
                        immAssetAllocations={immAssetAllocations}
                        isFetching={immPortfolioDetails.get('isFetching')}
                        showRentabilityPercentage={true}
                        onAccordionRecordLinkClick={
                            this.handleAccordionDistributionTableLink
                        }
                    />
                </div>
                {movementsLink}
            </div>
        );
    }

    handleEvolutionChartOptionChange(value) {
        this.props.evolutionChartChangeOption(value);
    }

    expectedProfitabilityRecordLink(value) {
        recordLink(
            PROC_RA_PORTFOLIO_TRACKING_INTERACTION,
            PROC_RA_PORTFOLIO_TRACKING_EXPECTED_PROFITABILITY,
            value + PROC_RA_YEARS,
        );
    }

    handleProjectionChartYearsClick(value) {
        const {
            expectedProfitabilityChangeYears,
            immPortfolioDetails,
            immGlobalPosition,
            match: { params: { portfolioId } },
        } = this.props;

        this.expectedProfitabilityRecordLink(value);
        expectedProfitabilityChangeYears(value);
        const product = immPortfolioDetails.getIn(['product', 'typeOfProduct']);
        const balance = immPortfolioDetails.getIn(['totals', 'investedAmount']);
        const recurringContributionAmount = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
            'recurringTransfers',
            'amount',
        ]);
        const periodicity = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
            'recurringTransfers',
            'recurringCode',
        ]);
        this.props.requestProjectionChart({
            chartYears: value,
            product,
            balance,
            portfolioId,
            freq: periodicity,
            mntPayment: recurringContributionAmount,
        });
    }

    getCancelMessage(isCancelInProgress) {
        let message;
        const informativeTitle = formatText(
            'raPortfolioTracking-raPortfolioTracking_cancelProgressTitle',
        );

        const informativeContent = (
            <FormattedText value="raPortfolioTracking-raPortfolioTracking_cancelProgressDescription" />
        );

        if (isCancelInProgress) {
            message = (
                <div className="row">
                    <div className="col-md-12 grid-view--fix-cell-separation">
                        <RAInformativeBox title={informativeTitle}>
                            {informativeContent}
                        </RAInformativeBox>
                    </div>
                </div>
            );
        }
        return message;
    }

    getChangeInProgressMessage(isChangeInProgress) {
        let message;
        const informativeTitle = formatText(
            'raPortfolioTracking-raPortfolioTracking_changeInProgressTitle',
        );

        if (isChangeInProgress) {
            message = (
                <div className="row">
                    <div className="col-md-12 grid-view--fix-cell-separation">
                        <RAInformativeBox title={informativeTitle}>
                            <FormattedText value="raPortfolioTracking-raPortfolioTracking_changeInProgressDescription" />
                        </RAInformativeBox>
                    </div>
                </div>
            );
        }
        return message;
    }

    handleFeatureModal(link, type) {
        const { history, immRAFeatureFlag } = this.props;
        if (!immRAFeatureFlag.get(type)) {
            this.props.featureModalToggle();
        } else {
            history.push(link);
        }
    }

    getMoreOptions(immPortfolio) {
        const {
            immCheckStatus,
            immRAFeatureFlag,
            immFlagBasedFeatures,
        } = this.props;
        const reimbursementLink = `${RA_REIMBURSEMENT_URL}/${this.props.match.params.portfolioId}`;
        const changeProductLink = `${RA_MODIFY_PLAN_URL}/${this.props.match.params.portfolioId}`;
        const cancelServiceLink = `${RA_CANCEL_PLAN_URL}/${this.props.match.params.portfolioId}`;
        const manageContributionsLink = `${RA_MANAGEMENT_CONTRIBUTION_URL}/${this.props.match.params.portfolioId}`;
        const ordersAndMovementsLink = `${RA_LAST_MOVEMENTS_URL}/${PORTFOLIO_TRACK_URL_PARA}/${this.props.match.params.portfolioId}`;
        const accountDetailsLink = `${RA_ACCOUNT_DETAILS_URL}/${this.props.match.params.portfolioId}`;
        const associateObjectiveLink = `${RA_ASSOCIATE_OBJECTIVE_URL}/${this.props.match.params.portfolioId}`;
        const maxTypeOfProduct = immPortfolio.getIn([
            'product',
            'maxTypeOfProduct',
        ]);
        const balance = immPortfolio.getIn(['keyFigures', 'valuation']);
        const isPartialReimbursementPossible =
            balance >= MINIMUM_STRATEGY_BALANCE_REIMBURSEMENT;
        return [
            {
                link: manageContributionsLink,
                text: formatText(
                    'raGlobal-raGlobal_moreOptionsManagementContribution',
                ),
                visible: !!(
                    immPortfolio && immPortfolio.get('recurringTransfers')
                ),
            },
            {
                handleClick: () => {
                    recordLink(
                        PROC_RA_PORTFOLIO_TRACKING_INTERACTION,
                        PROC_RA_OPTIONS_MENU,
                        PROC_RA_PORTFOLIO_TRACKING_REFUND,
                    );
                    if (
                        immRAFeatureFlag.get('refund') &&
                        isPartialReimbursementPossible
                    ) {
                        this.handleFeatureModal(reimbursementLink, 'refund');
                    } else if (!immRAFeatureFlag.get('refund')) {
                        this.handleFeatureModal(reimbursementLink, 'refund');
                    } else if (!isPartialReimbursementPossible) {
                        this.handlePartialRefundModalToggle();
                    }
                },
                text: formatText('broker-globalPositionRAPopOverRefundRequest'),
                visible: true,
            },
            {
                handleClick: () => {
                    recordLink(
                        PROC_RA_PORTFOLIO_TRACKING_INTERACTION,
                        PROC_RA_OPTIONS_MENU,
                        PROC_RA_TRACKING_ORDERS_MOVEMENTS,
                    );
                },
                link: ordersAndMovementsLink,
                text: formatText('broker-globalPositionRAPopOverMovements'),
                visible: true,
            },
            {
                handleClick: () => {
                    recordLink(
                        PROC_RA_PORTFOLIO_TRACKING_INTERACTION,
                        PROC_RA_OPTIONS_MENU,
                        PROC_RA_PORTFOLIO_TRACKING_MODIFY_STRATEGY,
                    );
                    if (
                        maxTypeOfProduct === SUITABILITY_TEST_HIGH_CONSERVATIVE
                    ) {
                        this.handleModifyModalClick();
                    } else if (
                        isTestValid(immCheckStatus) ||
                        !immFlagBasedFeatures.get(MODIFY_SUITABILITY_TEST)
                    ) {
                        this.handleFeatureModal(
                            changeProductLink,
                            'changeProduct',
                        );
                    } else {
                        this.setState({ showModalTestExpired: true });
                    }
                },
                text: formatText(
                    'broker-globalPositionRAPopOverModifyStrategy',
                ),
                visible: true,
            },
            {
                handleClick: () => {
                    recordLink(
                        PROC_RA_PORTFOLIO_TRACKING_INTERACTION,
                        PROC_RA_OPTIONS_MENU,
                        PROC_RA_TRACKING_SUITABILITY_TEST,
                    );
                },
                link: SUITABILITY_TEST_STATUS_URL,
                text: formatText(
                    'broker-globalPositionRAPopOverSuitabilityTest',
                ),
                visible: true,
            },
            {
                handleClick: () => {
                    recordLink(
                        PROC_RA_PORTFOLIO_TRACKING_INTERACTION,
                        PROC_RA_OPTIONS_MENU,
                        PROC_RA_PORTFOLIO_TRACKING_CANCEL_PORTFOLIO,
                    );
                    this.handleFeatureModal(cancelServiceLink, 'cancelService');
                },
                text: formatText('broker-globalPositionRAPopOverCancelService'),
                visible: true,
            },
            {
                handleClick: () => {
                    recordLink(
                        PROC_RA_PORTFOLIO_TRACKING_INTERACTION,
                        PROC_RA_OPTIONS_MENU,
                        PROC_RA_PORTFOLIO_TRACKING_ACCOUNT_DETAILS,
                    );
                },
                link: accountDetailsLink,
                text: formatText('broker-getAccountDetails'),
                visible: true,
            },
            {
                handleClick: () => {
                    recordLink(
                        PROC_RA_PORTFOLIO_TRACKING_INTERACTION,
                        PROC_RA_OPTIONS_MENU,
                        PROC_RA_PORTFOLIO_TRACKING_ASSOCIATE_OBJECTIVE,
                    );
                },
                link: associateObjectiveLink,
                text: formatText('broker-raAssociateObjectiveLink'),
                visible: isTestValid(immCheckStatus),
            },
        ];
    }

    getProductIcon() {
        const { immPortfolioDetails } = this.props;
        const product = immPortfolioDetails.getIn(['product', 'typeOfProduct']);
        if (!product) {
            return false;
        }
        const iconTitleClass = `ra-portfolio-tracking-view__product-icon ${headerIcons[product]}`;

        return <i className={iconTitleClass} />;
    }

    buildFeatureModal() {
        const { immRAFeatureFlag, featureModalToggle } = this.props;
        return (
            <RAFeatureFlagModal
                immRAFeatureFlag={immRAFeatureFlag}
                featureModalToggle={featureModalToggle}
            />
        );
    }

    buildPartialReimbursementModal() {
        const { isPartialRefundModalOpen } = this.state;
        const modalTitle = (
            <FormattedText
                className="ra-portfolio-tracking-view__reimbursement-modal-title"
                value="raReimbursementModal-raReimbursementModal_title"
            />
        );
        const modalContent = (
            <FormattedText value="raReimbursementModal-raReimbursementModal_contentText" />
        );
        return (
            <OKModal
                content={modalContent}
                footerType="action"
                isOpen={isPartialRefundModalOpen}
                onPrimaryButtonClick={this.handlePartialRefundModalToggle}
                primaryButtonText="raReimbursementModal-raReimbursementModal_CTA"
                onCloseCallback={this.handlePartialRefundModalToggle}
                shouldCloseOnOverlayClick={false}
                title={modalTitle}
                titleAlignment="center"
            />
        );
    }

    handleContributionsManageClick() {
        recordLink(
            PROC_RA_PORTFOLIO_TRACKING_INTERACTION,
            PROC_RA_MANAGE_CONTRIBUTIONS,
        );
    }

    handleAdditionalContribution() {
        const {
            history,
            immRAFeatureFlag,
            match: {params: { portfolioId } },
        } = this.props;
        recordLink(
            PROC_RA_PORTFOLIO_TRACKING_INTERACTION,
            PROC_RA_NEW_CONTRIBUTION,
        );
        if (
            !immRAFeatureFlag.get('recurringContribution') &&
            !immRAFeatureFlag.get('additionalContribution')
        ) {
            this.props.featureModalToggle();
        } else {
            const additionalContributionLink = `${RA_ADDITIONAL_CONTRIBUTION_URL}/${portfolioId}`;
            history.push(additionalContributionLink);
        }
    }

    buildModifyWarningModal() {
        const { immSuitabilityTest } = this.props;
        const investProfile = immSuitabilityTest.getIn(
            ['results', 0, 'clientRiskProfileTitle'],
            '',
        );

        return (
            <RAModifyPlanWarningModal
                isOpen={this.state.isModifyModalOpen}
                onRequestClose={this.handleModifyModalClose}
                investProfile={investProfile}
            />
        );
    }

    handleFundNotificationClose() {
        this.setState({
            showFundTrasnferNotification: false,
        });
    }

    buildFundTransferNotification() {
        const {
            immGlobalPosition,
            immProfile,
            match: { params: { portfolioId } },
            setSinglePortfolioNotificationClosed,
            setSinglePortfolioNotificationDisabled,
        } = this.props;
        const portfolio = immGlobalPosition.getIn(['portfolios', portfolioId]);
        const hiringMethod = portfolio.get('hiringMethod');
        const fundsTransferStepsWidgetClosed = portfolio.getIn([
            'state',
            'fundsTransferStepsWidgetClosed',
        ]);
        let currentStep = 0;
        if (
            !fundsTransferStepsWidgetClosed &&
            hiringMethod === RA_PORTFOLIO_FUND_HIRING_METHOD
        ) {
            const funded = portfolio.getIn(['state', 'funded']);
            const fullyFunded = portfolio.getIn(['state', 'fullyFunded']);
            const portfolioOrderAndMovementURL = `${RA_LAST_MOVEMENTS_URL}/${PORTFOLIO_TRACK_URL_PARA}/${portfolioId}`;
            const userName = immProfile.get('fullname');
            const isNotificationClosed = portfolio.get('isNotificationClosed');
            if (!funded && !fullyFunded) {
                currentStep = RA_FUND_TRANSFER_STEP1;
            } else if (funded && !fullyFunded) {
                currentStep = RA_FUND_TRANSFER_STEP2;
            } else if (funded && fullyFunded) {
                currentStep = RA_FUND_TRANSFER_STEP3;
            }
            const content = !isNotificationClosed ? (
                <div className="row">
                    <div className="col-xs-12 col-md-12 ra-portfolio-tracking-view__fund-notification">
                        <RAFundTransferNotification
                            onClose={this.handleFundNotificationClose}
                            currentStep={currentStep}
                            forSinglePortfolio={true}
                            movementLink={portfolioOrderAndMovementURL}
                            userName={userName}
                            closeNotification={
                                setSinglePortfolioNotificationClosed
                            }
                            disableNotification={
                                setSinglePortfolioNotificationDisabled
                            }
                            portfolioId={portfolioId}
                        />
                    </div>
                </div>
            ) : null;
            return content;
        }
    }

    handleModalTestExpiredLink() {
        const {
            history,
            setOrigin,
            match: { params: { portfolioId } },
        } = this.props;
        setOrigin(RA_SUITABILITY_TEST_MODIFYPORTFOLIO_OPERATION, portfolioId);
        history.push(RA_SUITABILITY_TEST_URL);
    }

    handleCloseModalTestExpired() {
        this.setState({ showModalTestExpired: false });
    }

    buildTestExpiredModal() {
        const { showModalTestExpired } = this.state;
        const content = (
            <FormattedText value="modalTestExpired-modalTestExpired_contentDescription" />
        );
        const title = (
            <FormattedText value="modalTestExpired-modalTestExpired_titleDescription" />
        );
        const contentFooter = (
            <div className="ra-portfolio-tracking-view__modal">
                <OKButton onClick={this.handleModalTestExpiredLink}>
                    <FormattedText value="modalTestExpired-modalTestExpired_buttonDescription" />
                </OKButton>
            </div>
        );
        return (
            <OKModal
                isOpen={showModalTestExpired}
                shouldCloseOnOverlayClick={false}
                description={content}
                descriptionAlignment="center"
                title={title}
                titleAlignment="center"
                contentFooter={contentFooter}
                onCloseCallback={this.handleCloseModalTestExpired}
            />
        );
    }

    handleGoBackButtonClick() {
        recordLink(PROC_RA_PORTFOLIO_TRACKING_INTERACTION, PROC_RA_GO_BACK);
    }

    onCalculateLinkClick() {
        recordLink(
            PROC_RA_PORTFOLIO_TRACKING_INTERACTION,
            PROC_RA_HELP_PATRIMONY_CALCULATION,
        );
    }

    handleReturnTestClick() {
        recordLink(
            PROC_RA_GLOBAL_POSITION_INTERACTION,
            PROC_RA_GLOBAL_POSITION_RETURN_TEST,
        );
        this.props.history.push(RA_SUITABILITY_TEST_URL);
    }

    handleCloseUnsuitableTest() {
        this.setState({
            showUnsuitableTestCancelation: false,
        });
    }

    buildUnsuitableTestCancelationBox() {
        const { showUnsuitableTestCancelation } = this.state;
        const link = (
            <OKLink onClick={this.handleReturnTestClick}>
                <FormattedText value="raGlobalPosition-raGlobalPosition_unsuitableTestNotificationLinkText" />
            </OKLink>
        );
        return (
            <div className="ra-portfolio-tracking-view__notifications-box">
                <OKMessage
                    type="informative"
                    modifier="dark-bg"
                    closeButton
                    visible={showUnsuitableTestCancelation}
                    onCloseButtonClick={this.handleCloseUnsuitableTest}
                >
                    <FormattedTextWithComponents
                        value="raGlobalPosition-raGlobalPosition_unsuitableTestNotificationContent"
                        injectedComponents={[link]}
                    />
                </OKMessage>
            </div>
        );
    }

    render() {
        const {
            fetchAlerts,
            immCheckStatus,
            immFlagBasedFeatures,
            immGlobalPosition,
            immPortfolioDetails,
            immAccountDetails,
            immRAAlerts,
            match: { params: { portfolioId } },
        } = this.props;

        const isAllowed = immFlagBasedFeatures.get(MODIFY_SUITABILITY_TEST);
        const isExpiredTest = isTestExpired(immCheckStatus);
        const showTestExpiredAlert = isAllowed && isExpiredTest;
        const testExpiredModal = showTestExpiredAlert
            ? this.buildTestExpiredModal()
            : null;

        const coverTitle = immPortfolioDetails.get('portfolioName');
        const productIcon = this.getProductIcon();
        const portfolioDistributionTitle =
            formatText('raPortfolioDistributionWidget-title') +
            ' ' +
            coverTitle;
        const mappingBreadcrumb = this.getBreadcrumb();
        const portfolioEvolutionElement = this.getPortfolioEvolution();
        const expectedProfitabilityElement = this.getExpectedProfitability();
        const portfolioDistributionElement = this.getPortfolioDistribution();
        const immPortfolio = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
        ]);

        const isCancelInProgress = immPortfolioDetails.getIn([
            'state',
            'cancelled',
        ]);
        const isChangeInProgress = immPortfolioDetails.getIn([
            'state',
            'productChangeInProgress',
        ]); //strategyChange
        const cancelInProgressMessage = this.getCancelMessage(
            isCancelInProgress,
        );
        const changeInProgressMessage = this.getChangeInProgressMessage(
            isChangeInProgress,
        );
        const moreOptionsArray = immPortfolio
            ? this.getMoreOptions(immPortfolio)
            : [];
        let rightContent = (
            <RARoboMoreOptionsButton
                moreOptions={moreOptionsArray}
                buttonDisabled={isCancelInProgress}
                onGoBackButtonClick={this.handleGoBackButtonClick}
            />
        );
        //const coverIconTitle = !!portfolioSelected ? this.buildCoverIconTitle(portfolioSelected.icon) : '';

        const periodicTransferAmount = immPortfolioDetails.getIn([
            'periodicTransfer',
            'amount',
        ]);
        const periodicTransferDate = immPortfolioDetails.getIn([
            'periodicTransfer',
            'nextDate',
        ]);
        const periodicityTransferCode = immPortfolioDetails.getIn([
            'periodicTransfer',
            'code',
        ]);
        const errorTitle = immPortfolioDetails.get('errorTitle');
        const errorTitleMessage = formatText(
            'raManagementPlan-raManagementPlan_customNameError',
        );
        const managementLink = `${RA_MANAGEMENT_CONTRIBUTION_URL}/${portfolioId}`;
        const emptyEvolutionModal = this.buildEmptyEvolutionModal();
        const featureModal = this.buildFeatureModal();
        const modifyWarningModal = this.buildModifyWarningModal();
        const fundTransferNotification =
            this.state.showFundTrasnferNotification &&
            this.buildFundTransferNotification();
        const partialReimbursementModal = this.buildPartialReimbursementModal();
        let cgdNumber, subtitle;
        if (immAccountDetails) {
            cgdNumber = immAccountDetails.get('cgdNumber');
            if (cgdNumber) {
                subtitle = <RACgdNumber cgdNumberVal={cgdNumber} />;
            }
        }
        const unsuitableTestBox =
            immFlagBasedFeatures.get('sign_suitability_test_not_suitable') &&
            immCheckStatus.get('nonSuitableTest')
                ? this.buildUnsuitableTestCancelationBox()
                : null;

        return (
            <div className="ra-portfolio-tracking-view grid-view">
                {testExpiredModal}
                <div className="container-fluid">
                    <div className="row">
                        <RACover
                            breadcrumb={mappingBreadcrumb}
                            section="goal"
                            showHelp={false}
                            title={coverTitle}
                            rightContent={rightContent}
                            iconTitle={productIcon}
                            subtitle={subtitle}
                            titleEditable={true}
                            fontSize={RA_COVER_FONT}
                            onUpdateTitle={this.handleTitleChange}
                            errorTitle={errorTitle}
                            errorTitleMessage={errorTitleMessage}
                        />
                    </div>
                </div>
                <div className="row ra-portfolio-tracking-view__container">
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            {cancelInProgressMessage}
                            {changeInProgressMessage}
                            {fundTransferNotification}
                            {unsuitableTestBox}
                            <div className="row">
                                <div className="col-xs-12 col-md-8">
                                    <div className="row">
                                        <div className="col-md-12 grid-view--fix-cell-separation">
                                            {emptyEvolutionModal}
                                            <RADistributionWidget
                                                hasRoboHired={true}
                                                immRoboAdvisor={
                                                    immPortfolioDetails
                                                }
                                                distributionTitle={
                                                    portfolioDistributionTitle
                                                }
                                                distributionInfo="raPortfolioDistributionWidget-info"
                                                buildServiceCostModal={true}
                                                showSimpleReturnPercent={true}
                                                showProfitabilityTooltip={false}
                                                calculateLinkClick={
                                                    this.onCalculateLinkClick
                                                }
                                            />
                                        </div>
                                        <div className="col-md-12 grid-view--fix-cell-separation">
                                            {portfolioEvolutionElement}
                                        </div>
                                        <div className="col-md-12 grid-view--fix-cell-separation">
                                            {expectedProfitabilityElement}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-4">
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-6 col-md-12 grid-view--fix-cell-separation">
                                            <RAContributions
                                                periodicTransferAmount={
                                                    periodicTransferAmount
                                                }
                                                periodicTransferDate={
                                                    periodicTransferDate
                                                }
                                                periodicityTransferCode={
                                                    periodicityTransferCode
                                                }
                                                portfolioId={portfolioId}
                                                isCancelInProgress={
                                                    isCancelInProgress
                                                }
                                                managementLink={managementLink}
                                                additionalContributionClick={
                                                    this
                                                        .handleAdditionalContribution
                                                }
                                                contributionsManageLinkClick={
                                                    this
                                                        .handleContributionsManageClick
                                                }
                                            />
                                        </div>
                                        <div className="col-xs-12 col-sm-6 col-md-12 grid-view--fix-cell-separation">
                                            <RAAlertsWidget
                                                fetchAlerts={fetchAlerts}
                                                immAlertsData={immRAAlerts}
                                            />
                                        </div>
                                        <div className="col-xs-12 col-sm-6 col-md-12 grid-view--fix-cell-separation">
                                            <BrokerInvestmentSpecialist />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                {portfolioDistributionElement}
                                {partialReimbursementModal}
                                {featureModal}
                                {modifyWarningModal}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

RAPortfolioTrackingView.propTypes = {
    fetchMyInvestments: PropTypes.func.isRequired,
    readPortfolioFromGlobalPosition: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immGlobalPosition: PropTypes.object.isRequired,
    immPortfolioEvolution: PropTypes.object.isRequired,
    evolutionChartChangeOption: PropTypes.func.isRequired,
    immExpectedProfitability: PropTypes.object.isRequired,
    immBrokerMyInvestments: PropTypes.object.isRequired,
    expectedProfitabilityChangeYears: PropTypes.func,
    immCheckStatus: PropTypes.object.isRequired,
    immPortfolioDetails: PropTypes.func.isRequired,
    requestProjectionChart: PropTypes.func.isRequired,
    requestPortfolioEvolutionChart: PropTypes.func,
    immEvolutionChartData: PropTypes.object.isRequired,
    immPortfoliosNameHistory: PropTypes.object.isRequired,
    immRAAlerts: PropTypes.object.isRequired,
    immSuitabilityTest: PropTypes.object.isRequired,
    fetchAlerts: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    resetExpectedProfitability: PropTypes.func.isRequired,
    setHeaderTitleError: PropTypes.func.isRequired,
    immRAFeatureFlag: PropTypes.object.isRequired,
    featureModalToggle: PropTypes.func.isRequired,
    fetchFeatureFlag: PropTypes.func.isRequired,
    getCGDAccountNumberVal: PropTypes.func.isRequired,
    getDisplayNames: PropTypes.func.isRequired,
    immAccountDetails: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    updatePortfolioName: PropTypes.func.isRequired,
    removeFilter: PropTypes.func.isRequired,
    setOrigin: PropTypes.func.isRequired,
    setOriginRedirection: PropTypes.func.isRequired,
    setSinglePortfolioNotificationClosed: PropTypes.func.isRequired,
    setSinglePortfolioNotificationDisabled: PropTypes.func.isRequired,
};

module.exports = connect(
    state => ({
        immAccounts: state.accounts,
        immAccountDetails: state.raAccountDetails,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immGlobalPosition: state.raGlobalPosition,
        immPortfoliosNameHistory: state.raPortfoliosNameHistory,
        immPortfolioEvolution: state.raPortfolioEvolution,
        immExpectedProfitability: state.raExpectedProfitability,
        immBrokerMyInvestments: state.brokerMyInvestments,
        immCheckStatus: state.raCheckStatus,
        immProfile: state.profile,
        immPortfolioDetails: state.raPortfolioDetails,
        immEvolutionChartData: state.raEvolutionChartOjectiveTrackingReducer,
        immRAAlerts: state.raAlertsReducer,
        immRAFeatureFlag: state.raFeatureFlag,
        immSuitabilityTest: state.raSuitabilityTest,
    }),
    {
        fetchMyInvestments: brokerMyInvestments.fetchMyInvestments,
        readPortfolioFromGlobalPosition:
            portfolioDetailsActions.readPortfolioFromGlobalPosition,
        evolutionChartChangeOption:
            raEvolutionChartOjectiveTracking.portfolioEvolutionChangeOption,
        expectedProfitabilityChangeYears:
            expectedProfitabilityActions.changeYears,
        getDisplayNames: raPortfoliosNameHistoryActions.getDisplayNames,
        fetchAlerts: RAAlertsActions.fetchAlerts,
        requestProjectionChart:
            expectedProfitabilityActions.requestProjectionChart,
        requestPortfolioEvolutionChart:
            raEvolutionChartOjectiveTracking.requestPortfolioEvolutionChart,
        reset: portfolioDetailsActions.reset,
        resetExpectedProfitability:
            expectedProfitabilityActions.resetExpectedProfitability,
        setHeaderTitleError: portfolioDetailsActions.setHeaderTitleError,
        featureModalToggle: RAFeatureFlagActions.featureModalToggle,
        fetchFeatureFlag: RAFeatureFlagActions.fetchFeatureFlag,
        updatePortfolioName: portfolioDetailsActions.updatePortfolioName,
        getCGDAccountNumberVal: raAccountDetailsActions.getCGDAccountNumber,
        removeFilter: raLastMovementActions.removeFilter,
        setOrigin: suitabilityActions.setOrigin,
        setOriginRedirection: raGlobalPosition.setOriginRedirection,
        setSinglePortfolioNotificationClosed:
            raGlobalPosition.setSinglePortfolioNotificationClosed,
        setSinglePortfolioNotificationDisabled:
            raGlobalPosition.setSinglePortfolioNotificationDisabled,
    },
)(withRouter(RAPortfolioTrackingView));
